import styled from 'styled-components';

import { LoadingIndicator } from '@spotify-internal/encore-creator-web';

export const DarkModeLoadingIndicator = styled(LoadingIndicator)`
  /*
   * Calculated using https://codepen.io/sosuke/pen/Pjoqqp on dark mode
   * klein blue (#7F80FA) with a loss of 0.1
   */
  filter: invert(47%) sepia(88%) saturate(438%) hue-rotate(201deg)
    brightness(96%) contrast(104%);
`;
